<app-table-header
  (reload)="onRefreshList(false)"
  [loading]="loading"
  [withExportOption]="!!data.info.exportTableName"
  (exportBtnClicked)="exportBtnClicked()"
></app-table-header>
<nz-table appColumnLayout id="bulk-container-comments-list-table"
  #tableRef
  nzShowSizeChanger
  [nzData]="data.results"
  [nzLoading]="loading"
  [nzTotal]="data.info.totalResults"
  [nzFrontPagination]="false"
  [nzPageSize]="pageSize"
  [nzPageIndex]="data.info.page"
  (nzQueryParams)="onQueryParamsChange($event)"
  >
  <thead>
    <tr>
      <th nzColumnKey="createdAt" [nzSortFn]="true">Datum</th>
      <th nzColumnKey="comment" [nzSortFn]="true">Kommentar</th>
      <th nzColumnKey="user.fullName" [nzSortFn]="true">Ersteller</th>
      <th nzColumnKey="actions" nzRight></th>
    </tr>
  </thead>
  <tbody>
    @for (val of data.results; track val) {
      <tr>
        <td>
          {{ val.createdAt | datetimeFormat }}
        </td>
        <td>
          @if (!val.isEdited) {
            {{ val.comment }}
          }
          @if (val.isEdited) {
            <textarea nz-input [(ngModel)]="val.comment"></textarea>
          }
        </td>
        <td>
          {{ val.user.fullName }}
        </td>
        <td nzRight>
          <div class="actions">
            <app-icon-button
              [icon]="!val.isEdited ? 'edit' : 'check'"
              [ariaLabel]="(val.isEdited ? 'Kommentar speichern' : 'Kommentar bearbeiten') + ': ' + val.user.fullName"
              (pressed)="updateComment(val)"
            ></app-icon-button>
            @if (val.isEdited) {
              <app-icon-button
                icon="close"
                ariaLabel="Bearbeitung abbrechen"
                (pressed)="val.isEdited = false"
              ></app-icon-button>
            }
            <app-icon-button
              icon="delete"
              [ariaLabel]="'Kommentar löschen: ' + val.user.fullName"
              confirmTitle="Sind Sie sicher?"
              (confirmed)="deleteComment(val.id)"
            ></app-icon-button>
          </div>
        </td>
      </tr>
    }
  </tbody>
</nz-table>

<app-export-table-modal #exportTableModalComponent></app-export-table-modal>
